import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GeneralConstants } from '../constants/GeneralConstants';
import { Subject } from 'rxjs';
import { SCPassData } from '../ai-modal-sc/ai-modal-sc.component';
import { SimilarCandidateDetails } from '../common-interfaces-classes/SimilarCandidate';
import { FPN } from '../constants/FilterParamNames';

@Injectable({
  providedIn: 'root'
})
export class SimilarCandidateService {

  constructor(private activatedRoute: ActivatedRoute) { }

  private listingCalledFromSimilarCandidate = false;
  private scLoaderSub: Subject<SCPassData> = new Subject();

  get isListingCalledFromSimilarCandidate() {
    return this.listingCalledFromSimilarCandidate || this.hasQPTypeSimilarCandidates;
  }

  setListingCalledFromSimilarCandidate(listingCalledFromSimilarCandidate) {
    this.listingCalledFromSimilarCandidate = listingCalledFromSimilarCandidate;
  }

  get hasQPTypeSimilarCandidates() {
    const type = this.activatedRoute.snapshot.queryParams['type'];
    return GeneralConstants.TYPE.SIMILAR_CANDIDATE === type;
  }

  public emitScLoaderDataEvent(data: SCPassData) {
    this.scLoaderSub.next(data);
  }

  public get scLoaderObs() {
    return this.scLoaderSub.asObservable();
  }

  public modifyRequestForSCCount(request, scFilterData: SimilarCandidateDetails) {
    request['similarcandidates_industries'] = !Array.isArray(scFilterData?.jobindustryname) ? [scFilterData?.jobindustryname] : scFilterData?.jobindustryname;
    request['similarcandidates_locations'] = scFilterData?.currentlocation;
    request['similarcandidates_skills'] = scFilterData?.skills;
    request['similarcandidates_companysizes'] = scFilterData?.companysize ? scFilterData?.companysize : [];
    request['similarcandidates_fromyearsofexperience'] = scFilterData?.fromYrsOfExperience ? [scFilterData?.fromYrsOfExperience] : [];
    request['similarcandidates_toyearsofexperience'] = scFilterData?.toYrsOfExperinece ? [scFilterData?.toYrsOfExperinece] : [];
    request['similarcandidates_totaltenure'] = scFilterData?.totaltenure;
    request['similarcandidates_jobtitles'] = scFilterData?.jobtitle || [];
    request['similarcandidates_companies'] = scFilterData?.jobcompanyname || [];
    request["continentstobeincluded"] = scFilterData?.locationcontinent ? [scFilterData.locationcontinent] : [];
    request["exclude_persons"] = scFilterData?.elasticid ? [scFilterData.elasticid] : [];
    request.resultsize = 0;
    scFilterData.modal_open_reason !== "edit" && this.removeFilters(request);
  }

  private removeFilters(request: any) {
    console.log("remove filters called...");
    [
      //@ts-ignore
      ...FPN.FILTER_PARAMS,
      ...FPN.INSIGHTS_FILTER_PARAMS,
      ...FPN.MANDATORY_FILTER_PARAMS
    ]
    .forEach(property => {
      if (Reflect.has(request, property)) 
        delete request[property];
    });
  }

}
